// Previewing/reloading a receipt must never submit a physical print job.
// One explicit click produces at most one request while the dialog is open.
const pending = new WeakSet();
export function printTransferReceipt(frame) {
    const target = frame?.contentWindow;
    if (!target || pending.has(target)) return false;
    pending.add(target);
    let timer;
    const release = () => {
        clearTimeout(timer);
        target.removeEventListener("afterprint", release);
        pending.delete(target);
    };
    target.addEventListener("afterprint", release, { once: true });
    // Some kiosk drivers never emit afterprint. Allow an intentional retry later.
    timer = setTimeout(release, 60000);
    try {
        target.focus();
        target.print();
        return true;
    } catch (error) {
        release();
        throw error;
    }
}
